/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide-graphics/you-are-here': {
    width: 16,
    height: 16,
    viewBox: '0 0 159.92 140.03',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" d="M27.29 73.2L70 93.38 0 130.92z" _fill="#fff"/><path pid="1" d="M153.18 99.94a70 70 0 11-33.35-93.21 70 70 0 0133.35 93.21z" _fill="#fff"/><circle pid="2" cx="89.16" cy="70.31" r="63.5" _fill="#e25046"/></g></g>'
  }
})
